const constants = {
    ACTIVE_FILTER_STATES_COUNTY: [
        'Blekinge',
        'Dalarna',
        'Gavleborg',
        'Gotland',
        'Halland',
        'Jamtland',
        'Jonkoping',
        'Kalmar',
        'Kronoberg',
        'Norrbotten',
        'Skane',
        'Sodermanland',
        'Stockholm',
        'Uppsala',
        'Varmland',
        'Vasterbotten',
        'Vasternorrland',
        'Vastmanland',
        'VastraGotaland',
        'Orebro',
        'Ostergotland'
    ],
    ACTIVE_FILTER_STATES_ITEM_CONDITION: ['New', 'Used'],
    ACTIVE_FILTER_STATES_ITEM_STATUS: ['Sold', 'Ended', 'Unsold'],
    ACTIVE_FILTER_STATES_ITEM_TYPE: ['Auction', 'FixedPrice'],
    ACTIVE_FILTER_STATES_SELLER_TYPE: ['Private', 'Company'],
    FILTER_STATES_ALLOWED_BUYER_REGIONS: {
        SWEDEN: 'sweden;eu;international',
        EU: 'eu;international',
        INTERNATIONAL: 'international',
        NORDIC: 'nordic;international'
    },
    MODALS: {
        FILTER_MODAL: 'filterModal',
        CATEGORY_MODAL: 'categoryModal'
    }
} as const;

export default constants;

export type PossibleFilterStates =
    | (typeof constants.ACTIVE_FILTER_STATES_ITEM_CONDITION)[number]
    | (typeof constants.ACTIVE_FILTER_STATES_SELLER_TYPE)[number]
    | (typeof constants.ACTIVE_FILTER_STATES_ITEM_STATUS)[number]
    | (typeof constants.ACTIVE_FILTER_STATES_ITEM_TYPE)[number];

export enum FilterNames {
    BRAND = 'brand',
    CLOTHES_SIZE = 'clothes_size',
    CLOTHES_SIZE_CHILDREN = 'clothes_size_children',
    SHOE_SIZE = 'shoe_size'
}
